// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"m8-z"};